import { ContainerGlogal } from "@Components/ContainerGlogal"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { AntDesign, Entypo, Ionicons } from "@expo/vector-icons"
import React, { useState } from "react"
import { Text, View, StyleSheet, TouchableOpacity, ScrollView } from "react-native"
import Accordion from "react-native-collapsible/Accordion"
import { Divider } from "react-native-paper"

export const FAQ = () => {
    const SECTIONS = [
        {
            title: "Qu’est-ce que l’éducation thérapeuthique ?",
            content: `Le Diagnostic Éducatif permet d’évaluer vos besoins avec un professionnel et de personnaliser vos activités et vos objectifs.Le Diagnostic Éducatif nécessite de répondre à un questionnaire puis de plannifer un échange vidéo avec un soignant de l’équipe IVEHTE. Suite à cet entretien, vous aurez un programme précis et vous pourrez suivre votre progession grâce à l’application.`
        },
        {
            title: "Qu’est-ce que le “Diagnostic Éducatif” ?",
            content: `Le Diagnostic Éducatif permet d’évaluer vos besoins avec un professionnel et de personnaliser vos activités et vos objectifs.Le Diagnostic Éducatif nécessite de répondre à un questionnaire puis de plannifer un échange vidéo avec un soignant de l’équipe IVEHTE. Suite à cet entretien, vous aurez un programme précis et vous pourrez suivre votre progession grâce à l’application.`
        },
        {
            title: "Puis-je adapter mon programme ?",
            content: `Le Diagnostic Éducatif permet d’évaluer vos besoins avec un professionnel et de personnaliser vos activités et vos objectifs.Le Diagnostic Éducatif nécessite de répondre à un questionnaire puis de plannifer un échange vidéo avec un soignant de l’équipe IVEHTE. Suite à cet entretien, vous aurez un programme précis et vous pourrez suivre votre progession grâce à l’application.`
        },
        {
            title: "Puis-je modifier ma fiche patient ?",
            content: `Le Diagnostic Éducatif permet d’évaluer vos besoins avec un professionnel et de personnaliser vos activités et vos objectifs.Le Diagnostic Éducatif nécessite de répondre à un questionnaire puis de plannifer un échange vidéo avec un soignant de l’équipe IVEHTE. Suite à cet entretien, vous aurez un programme précis et vous pourrez suivre votre progession grâce à l’application.`
        }
    ]
    const [active, setActive] = useState([])
    const _renderSectionTitle = (section) => {
        return <View style={styles.content}></View>
    }

    const _renderHeader = (section, _, isActive) => {
        return (
            <View>
                <View
                    style={[
                        styles.header,
                        { backgroundColor: isActive ? baseColors.green.light : "white", marginTop: isActive ? 20 : 0 }
                    ]}
                >
                    <View style={{ flex: 9 }}>
                        <OpenSansText fontSize={16} fontWeight={"bold"}>
                            {section.title}
                        </OpenSansText>
                    </View>
                    <View style={{ flex: 2 }}></View>
                    <View style={{ flex: 1 }}>
                        <Entypo
                            name={isActive ? "chevron-up" : "chevron-down"}
                            color={baseColors.green.primary}
                            size={20}
                        />
                    </View>
                </View>
                {!isActive && (
                    <Divider
                        style={{ height: 1, marginTop: 15, marginBottom: 5, backgroundColor: baseColors.green.primary }}
                    />
                )}
            </View>
        )
    }

    const _renderContent = (section) => {
        return (
            <View style={styles.content}>
                <View style={{ padding: 15 }}>
                    <OpenSansText fontSize={15}>{section.content}</OpenSansText>
                </View>
            </View>
        )
    }

    return (
        <ContainerGlogal style={{ paddingTop: 10, padding: 20 }}>
            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 80 }}>
                <BreeSerifText fontSize={20}>Besoin d’aide ?</BreeSerifText>
                <OpenSansText style={{ marginTop: 10, marginBottom: 20 }}>
                    Consultez notre FAQ ou n’hésitez pas à nous contacter si vous ne trouvez pas de réponse à votre
                    question.
                </OpenSansText>
                <Accordion
                    sections={SECTIONS}
                    activeSections={active}
                    touchableComponent={TouchableOpacity}
                    renderSectionTitle={_renderSectionTitle}
                    renderHeader={_renderHeader}
                    renderContent={_renderContent}
                    onChange={(activeSession) => setActive(activeSession)}
                />
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 20,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    content: {
        borderBottomEndRadius: 8,
        borderBottomStartRadius: 8,
        backgroundColor: baseColors.green.light
    },
    header: {
        borderTopRightRadius: 8,
        borderTopLeftRadius: 8,
        padding: 15,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    headerText: {}
})
